import { FaExclamationCircle } from "react-icons/fa";
import styles from "./messageDisplay.module.scss";
import { MdClose } from "react-icons/md";

export default function MessageDisplay({ close, message }) {
  return (
    <>
      <div
        className={`${styles.alert} ${styles.alertError} ${styles.spacer}`}
        role="alert"
      >
        <i className={`fas fa-exclamation-circle ${styles.alertIcon}`}>
          <FaExclamationCircle />
        </i>
        <p className={styles.alertText}>{message}</p>
        <button
          type="button"
          className={styles.alertClose}
          data-dismiss="alert"
          aria-label="Close"
          onClick={() => close()}
        >
          <span aria-hidden="true">
            <i className={`fas fa-times-circle ${styles.alertClose}`}>
              <MdClose />
            </i>
          </span>
        </button>
      </div>
      {false && (
        <div
          className={`${styles.alert} ${styles.alertSecondary} ${styles.spacer}`}
          role="alert"
        >
          <i className="fas fa-exclamation-circle alert__icon"></i>
          <p className={styles.alertText}>This is a secondary alert</p>
          <button
            type="button"
            className="alert__close"
            data-dismiss="alert"
            aria-label="Close"
          >
            <span aria-hidden="true">
              <i className="fas fa-times-circle alert__close"></i>
            </span>
          </button>
        </div>
      )}
      {false && (
        <div className="alert alert__warning spacer" role="alert">
          <i className="fas fa-exclamation-triangle alert__icon"></i>
          <p className="alert__text">This is an warning alert</p>
          <button
            type="button"
            className="alert__close"
            data-dismiss="alert"
            aria-label="Close"
          >
            <span aria-hidden="true">
              <i className="fas fa-times-circle alert__close"></i>
            </span>
          </button>
        </div>
      )}
      {false && (
        <div className="alert alert__error spacer" role="alert">
          <i className="fas fa-minus-circle alert__icon"></i>
          <p className="alert__text">This is an error alert</p>
          <button
            type="button"
            className="alert__close"
            data-dismiss="alert"
            aria-label="Close"
          >
            <span aria-hidden="true">
              <i className="fas fa-times-circle alert__close"></i>
            </span>
          </button>
        </div>
      )}
      {false && (
        <div className="alert alert__success spacer" role="alert">
          <i className="fas fa-check-circle alert__icon"></i>
          <p className="alert__text">This is a success alert</p>
          <button
            type="button"
            className="alert__close"
            data-dismiss="alert"
            aria-label="Close"
          >
            <span aria-hidden="true">
              <i className="fas fa-times-circle alert__close"></i>
            </span>
          </button>
        </div>
      )}
    </>
  );
}
